import { Box, Typography } from '@mui/material';
import React from 'react';

interface SunrisePanelProps {
  title: string;
  subtitle: string;
  value: string;
}

export const SunrisePanel: React.FC<SunrisePanelProps> = ({ title, subtitle, value }) => {
  return (
    <Box
      sx={{
        mb: 3,
        p: 3,
        borderRadius: 2,
        background: 'linear-gradient(90deg, #f59e0b, #ea580c)',
        color: 'white',
      }}
    >
      <Typography variant="h4" fontWeight="500">
        {title}
      </Typography>
      <Typography variant="body1" sx={{ mt: 1, opacity: 0.9 }}>
        {subtitle}
      </Typography>
      <Typography variant="h4" fontWeight="500" sx={{ mt: 2 }}>
        {value}
      </Typography>
    </Box>
  );
};
